import {generateGuid} from '@packages/utilities/guid';
import type {InteractionId, TimelineId} from '@packages/systems/ix3/schema';

const GUID_LENGTH = 8;

const IX3_ID_PREFIXES = {
  interaction: 'i-',
  timeline: 't-',
} as const;

export function generateTimelineId(generate = generateGuid): TimelineId {
  return `${IX3_ID_PREFIXES.timeline}${generate(GUID_LENGTH)}`;
}

export function generateInteractionId(generate = generateGuid): InteractionId {
  return `${IX3_ID_PREFIXES.interaction}${generate(GUID_LENGTH)}`;
}
